export const queryKeys = {
  status: ["safegeo", "status"] as const,
  markets: ["safegeo", "markets"] as const,
  rules: ["safegeo", "rules"] as const,
  rule: (id: string) => ["safegeo", "rules", id] as const,
  stats: (key?: string | number, traffic: "live" | "preview" = "live") =>
    ["safegeo", "stats", key ?? "default", traffic] as const,
  embed: ["safegeo", "embed"] as const,
  settings: ["safegeo", "settings"] as const,
  design: ["safegeo", "design"] as const,
  stores: ["safegeo", "stores"] as const,
  versions: ["safegeo", "versions"] as const,
}
